import CompanyEditTemplate from "components/templates/CompanyEditTemplate/CompanyEditTemplate";

const CompanyEditPage = () => <CompanyEditTemplate />;

export default CompanyEditPage;
